import React, { FC, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Wrapper, StyledListItem } from "./styled";
import { getFromLocalStorage } from "../../lib/utils";

const mockMenuOptions = [
  {
    title: "Общие сведения",
    nameForClick: "GeneralInformation",
  },
  {
    title: "Образование",
    nameForClick: "Education",
  },
  {
    title: "Стаж",
    nameForClick: "Experience",
  },
  {
    title: "Медицинское страхование",
    nameForClick: "HealthInsurance",
  },
  {
    title: "Жилищные условия",
    nameForClick: "LivingConditions",
  },
  {
    title: "Воинский учет",
    nameForClick: "MilitaryRegistration",
  },
  {
    title: "Состав семьи",
    nameForClick: "FamilyComposition",
  },
  {
    title: "Аттестации",
    nameForClick: "Attestations",
  },
  {
    title: "Сертификация",
    nameForClick: "Certification",
  },
  {
    title: "Повышение квалификации",
    nameForClick: "Training",
  },
  {
    title: "Аккредитация",
    nameForClick: "Accreditation",
  },
  {
    title: "Профподготовка",
    nameForClick: "PreparatoryTraining",
  },
  {
    title: "Предыдущие места работы",
    nameForClick: "PreviousPlacesOfWork",
  },
  {
    title: "Прием в учреждение ?",
    nameForClick: "AdmissionToTheInstitution",
  },
  {
    title: "Звания и награды",
    nameForClick: "TitlesAndAwards",
  },
  {
    title: "Отпуска",
    nameForClick: "Vacations",
  },
  {
    title: "Сведения о наличии допуска к наркотическим средствам",
    nameForClick: "AccessToDrugs",
  },
  {
    title: "Обязательное комиссионное психиатрическое освидетельствование",
    nameForClick: "PsychiatricExamination",
  },
  {
    title: "Формирование документов",
    nameForClick: "FormationDocuments",
  },
  {
    title: "Больничные листы",
    nameForClick: "SickLeave",
  },
  {
    title: "Социальные сведения",
    nameForClick: "InformationSocial",
  },
  {
    title: "Доплаты",
    nameForClick: "AdditionalPayment",
  },
  {
    title: "Взыскания",
    nameForClick: "Penalties",
  },
  {
    title: "Назначения, перемещения",
    nameForClick: "AppointmentsMovements",
  },
  {
    title: "Поощрения",
    nameForClick: "Incentives",
  },
  {
    title: "Звания и награды",
    nameForClick: "TitlesAwards",
  },
  {
    title: "Увольнение",
    nameForClick: "Layoff",
  },
  {
    title: "Командировки",
    nameForClick: "BusinessTrips",
  },
  {
    title: "Трудовая деятельность",
    nameForClick: "WorkExperience",
  },
  {
    title: "Приказ на прием",
    nameForClick: "EmploymentOreder",
  },
];

const LeftMenu: FC<{ handleMenuItem: (menuItem: string) => void }> = ({
  handleMenuItem,
}) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState(
    getFromLocalStorage("menuItem")
  );

  const handleSelectMenuItem = (item: string) => {
    setSelectedMenuItem(item);
    handleMenuItem(item);
  };

  return (
    <Wrapper>
      {mockMenuOptions.map((option) => (
        <MenuItem
          key={option.title}
          onClick={() => handleSelectMenuItem(option.nameForClick)}
          selected={selectedMenuItem === option.nameForClick}
        >
          <StyledListItem>{option.title}</StyledListItem>
        </MenuItem>
      ))}
    </Wrapper>
  );
};

export default LeftMenu;
